import * as layouts from "layouts"
import * as routing from "brandguard/routing"
import * as bgapprovals from "brandguard/display/approval"

export function upload(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.image.approval.upload}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="img-brandguard-upload"
			>
				<bgapprovals.ImageActiveLink documentUrlgen={routing.document.approval.upload} textUrlgen={routing.text.approval.upload} videoUrlgen={routing.video.approval.upload} />
				<bgapprovals.navigation.ImagesNav />
				<bgapprovals.images.UploadDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function review(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.image.approval.review}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="img-brandguard-review"
			>
				<bgapprovals.ImageActiveLink documentUrlgen={routing.document.approval.review} textUrlgen={routing.text.approval.review} videoUrlgen={routing.video.approval.review} />
				<bgapprovals.navigation.ImagesNav />
				<bgapprovals.images.ReviewDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function approved(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.image.approval.approved}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="img-brandguard-approved"
			>
				<bgapprovals.ImageActiveLink documentUrlgen={routing.document.approval.approved} textUrlgen={routing.text.approval.approved} videoUrlgen={routing.video.approval.approved} />
				<bgapprovals.navigation.ImagesNav />
				<bgapprovals.images.ApprovedDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}

export function rejected(): JSX.Element {
	return (
		<bgapprovals.Container urlgen={routing.image.approval.rejected}>
			<layouts.containers.flex
				flexDirection="column"
				height="100%"
				overflow="hidden"
				data-testid="img-brandguard-rejected"
			>
				<bgapprovals.ImageActiveLink documentUrlgen={routing.document.approval.rejected} textUrlgen={routing.text.approval.rejected} videoUrlgen={routing.video.approval.rejected} />
				<bgapprovals.navigation.ImagesNav />
				<bgapprovals.images.RejectedDisplay />
			</layouts.containers.flex>
		</bgapprovals.Container>
	)
}
